import AllLeadsTemplate from "../../../../components/templates/LeadTemplates/AllLeadsTemplate/AllLeadsTemplate";

const AllLeads = () => {
  return <AllLeadsTemplate />;
};

export default AllLeads;
